import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import AssetImage from './AssetImage';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {ASSET_CONFIG} from '../../../models/dialogModels';
import * as imageHelper from '../../../helpers/imageHelper';
import _ from 'lodash';
import * as animationHelper from "../../../helpers/animationHelper";
class Image extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            screenObject: props.screenObject,
            userData: props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            image: {},
            screenStatus:"",
            checkComplete: false,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            isTracking: !appHelper.isDefined(this.props.isTracking) || (appHelper.isDefined(this.props.isTracking) && this.props.isTracking),
            continue_label: appHelper.getLocaleString("continue_label"),
            refValue : `image_${this.props.screenObject.asset_id}`,
            imageClass: "",
            imageStylesSet: false,
            updateImageStyles: false,
        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.setClass = this.setClass.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onCloseAssetDialog = this.onCloseAssetDialog.bind(this);
        this.launchAsset = this.launchAsset.bind(this);
        this.onRendered = this.onRendered.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getImageClass = this.getImageClass.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.allowDiagramZoom = this.allowDiagramZoom.bind(this);
        this.showDiagramTitle = this.showDiagramTitle.bind(this);
        this.showDiagramDescription = this.showDiagramDescription.bind(this);
        this.getImageStyles = _.debounce(this.getImageStyles.bind(this), 300);

        this.objectRef = React.createRef();
    }



    componentDidMount() {

        this.getAssets();
        this.getScreenStatus();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
        this.getImageStyles();
    }



    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if(this.state.lang !== nextProps.lang){
            let image = appHelper.getImageAsset(this.state.screenObject);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate(){

        if(this.state.checkComplete){
            this.onComplete();
        }
        /*if(!this.state.imageStylesSet){
            this.getImageStyles();
        }*/
    }

    getScreenStatus(){
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if(this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.onComplete();
        }else{
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                }else if(this.state.isResourceObject){
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }else{
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if(objectUserData.status === objectConstants.STATUS_COMPLETE){
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            }else{
                this.setState({checkComplete: true});
            }
        }
    }

    getAssets() {
        let image = appHelper.getImageAsset(this.state.screenObject);
        this.setState({image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image});
    }

    show() {
        let objectRef = this.objectRef.current;
        if(appHelper.isObjectEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.onRendered
            };
            animationHelper.showHeight(params);
        }
    }

    onRendered(){
        if(this.state.isResourceObject){
            this.props.callbacks.onObjectRendered();
        }
        this.getObjectStatus();
    }

    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let objectRef =  this.objectRef.current;
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo) && appHelper.isEleDefined(objectRef)) {
                    scrollTo(objectRef.offsetTop,true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else {
            return "not-started";
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        if(this.state.isTracking) {
            let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                if (!hasNextObject && !this.state.isResourceObject) {
                    this.handleProgression();
                    this.enableProgression();
                } else if (!hasNextObject && this.state.isResourceObject) {
                    this.handleProgression();
                }else if(this.state.isResourceObject) {
                    this.handleProgression();
                } else {
                    this.enableProgression();
                }

            } else {
                this.handleProgression();
            }
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked(){
        this.setState({showProgressionButton: false});
        if(this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject){
            this.handleProgression();
        }else{
            this.props.callbacks.navigateToNextScreen();
        }
    }

    onCloseAssetDialog(viewed){
        /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
        if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
            this.updateResourceObjectResult();
        }*/
    }

    launchAsset(){
        let childComponenents = [];
        let config = Object.assign({}, ASSET_CONFIG,
            {
                title: this.state.locale.label,
                onClose: this.onCloseAssetDialog,
                showCloseBtn: false,
                theme: "dialog-asset-image",
                sourceId: `image_btn_${this.state.screenObject.asset_id}`
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child = Object.assign({},child,{
                childComponent: AssetImage,
                componentProps: Object.assign({}, {
                    screenObject: this.state.screenObject,
                    callbacks:{}

                })
            });

            childComponenents = dataHelper.immutablePush(childComponenents, child);
        }
        config = Object.assign({},config,{
            childComponents: childComponenents
        });
        if(this.allowDiagramZoom()) {
            this.props.actions.setNewAssetDialog(config);
        }
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.launchAsset();
        }
    }

    getImageClass(){
        return appHelper.isDefined(this.state.imageClass) ? this.state.imageClass : "";
    }

    getImageStyles() {
        this.setState({
            imageStylesSet: true,
        });

        let refValue = this.objectRef.current;
        if(appHelper.isEleDefined(refValue) && appHelper.isDefined(this.state.screenObject.asset_id) && this.state.image.src.length > 0) {
            let excludePadding = (appHelper.isDefined(this.props.callbacks.hasSidePanel) && this.props.callbacks.hasSidePanel()) || (this.state.screenObject.image_size === objectConstants.IMAGE_SIZE_SPECIFIC && this.state.screenObject.asset_image_width === objectConstants.TOP_ASSET_IMAGE_WIDTH_100) || this.state.screenObject.image_size === objectConstants.IMAGE_SIZE_MAX;
            let assetStyles = imageHelper.checkAssetImageWidth(this.state.screenObject,this.state.image, refValue.offsetWidth, excludePadding).styles;
            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getDiagramImageClass(this.state.screenObject, this.state.image),
                doShow: true,
            });
        }
    }

    allowDiagramZoom(){
        return  this.state.screenObject.allow_diagram_zoom;

    }
    showDiagramTitle(){
        return this.state.screenObject.show_diagram_title;
    }

    showDiagramDescription(){
        return this.state.screenObject.show_diagram_description;
    }

    render() {
        return (
            <div className="a-c" ref={this.objectRef}>
                <div className="object-container">
                    {this.state.imageStylesSet
                        ?
                        <div className="image-object" onClick={this.launchAsset}
                             id={`image_btn_${this.state.screenObject.asset_id}`} onKeyDown={this.setKeyboardAccessibility}
                             role="link" tabIndex={0} style={this.state.imageStyles}>
                            <div className={`asset-image-wrapper ${this.state.imageClass}`} style={this.state.imageStyles}>
                                <img src={this.getImagePath(this.state.image.src)} alt={this.state.locale.label}/>
                                {this.allowDiagramZoom() &&
                                <div className="image-zoom"/>
                                }
                            </div>
                            {this.showDiagramTitle() || this.showDiagramDescription() ?
                                <div className="asset-content" >
                                    {
                                        appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0 && this.showDiagramTitle()
                                            ?
                                            <div className="title-container">
                                                <div className="title"
                                                     dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br/></p>" && this.allowDiagramZoom()
                                            ?
                                            <div className="desc-text"
                                                 dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                            :
                                            null
                                    }
                                </div>
                                :
                                null
                            }
                        </div>
                        :
                        null
                    }
                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>

        );
    }
}

Image.propTypes = {
    screenObject: PropTypes.object.isRequired,
    imageClass: PropTypes.string,
    imageStyles: PropTypes.object,
    callbacks: PropTypes.object.isRequired,
    isTracking: PropTypes.bool,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Image.contextTypes = {
    router: PropTypes.object
};

/*
* <ParagraphText screenObject={this.state.screenObject}
                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
                                   id={`${this.state.screenObject}_description`}
                                   class_name="document-description"
                                   objectKey={`description`}/>*/

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Image);



/** WEBPACK FOOTER **
 ** ./src/components/objects/image/Image.js
 **/